"use strict";
/**
 * @module Services.Control
 */
Object.defineProperty(exports, "__esModule", { value: true });
/**
 * Server result of from a ... request.
 */
var MessagingFilterSendResponse = /** @class */ (function () {
    /**
     * Create a new MessagingFilterSendResponse instance
     *
     * @param numberSent  the number of sessions the request was sent to
     * @param errors      any errors that occurred
     */
    function MessagingFilterSendResponse(numberSent, errors) {
        this.numberSent = numberSent;
        this.errors = errors;
        this.isSuccess = (errors.length === 0);
    }
    return MessagingFilterSendResponse;
}());
exports.MessagingFilterSendResponse = MessagingFilterSendResponse;



//////////////////
// WEBPACK FOOTER
// ./~/diffusion/src/internal/services/control/messaging-filter-send-response.js
// module id = 1906
// module chunks = 1